import { types } from '../../actions/backendCommon';

export const initialState = {
    isReloading: false,
    countdown: 0,
    isImmediate: undefined as boolean | undefined
};
type CommonState = typeof initialState;

interface ReducerAction {
    type?: string;
    payload?: {
        isImmediate?: boolean;
        countdown?: number;
    };
}

export default function commonReducer(state: CommonState | undefined, action: ReducerAction = {}): CommonState {
    const currentState = state ?? initialState;
    const { type, payload = {} } = action;

    switch (type) {
        case types.RELOAD:
            return {
                ...currentState,
                isReloading: true,
                isImmediate: payload.isImmediate,
                countdown: payload.countdown ?? 0
            };
        case types.UPDATE_RELOAD_COUNT_DOWN:
            return {
                ...currentState,
                countdown: Math.max(0, currentState.countdown - 1)
            };
        default:
            return currentState;
    }
}
